import type { LintingResponseType } from '@readme/api/src/mappings/ai/types';

export function isStyleguideResults(results): results is LintingResponseType['data']['styleguide'] {
  return results && Array.isArray(results) && results.length && 'score' in results[0];
}
